export default {"src":"https://fishbrain.com/_next/static/media/fish-animated.84fe6302.gif","height":100,"width":100,"blurWidth":0,"blurHeight":0};